import { push } from "react-router-redux";
import { startSubmit, stopSubmit, reset } from "redux-form";

import api from "../services/api";
import { showError, setLoading } from "./common.actions";
import { getAdminCompanyById } from "./company.actions";

export const SET_PAGINATION = "SET_PAGINATION";
export const SET_PAGE = "SET_PAGE";
export const SET_SORT = "SET_SORT";
export const SET_USER = "SET_USER";
export const SET_MATCHES = "SET_MATCHES";
export const SET_MATCHES_CSV = "SET_MATCHES_CSV";
export const SET_FEED = "SET_FEED";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_ADMIN_ERROR = "CREATE_ADMIN_ERROR";
export const SHOW_TOAST = "SHOW_TOAST";
export const GET_REFERRAL_CODES_START = "GET_REFERRAL_CODES_START";
export const GET_REFERRAL_CODES_SUCCESS = "GET_REFERRAL_CODES_SUCCESS";
export const GET_REFERRAL_CODES_ERROR = "GET_REFERRAL_CODES_ERROR";
export const UPDATE_REFERRAL_CODE_SUCCESS = "UPDATE_REFERRAL_CODE_SUCCESS";
export const UPDATE_REFERRAL_CODE_ERROR = "UPDATE_REFERRAL_CODE_ERROR";
export const CREATE_REFERRAL_CODE_SUCCESS = "CREATE_REFERRAL_CODE_SUCCESS";
export const CREATE_REFERRAL_CODE_ERROR = "CREATE_REFERRAL_CODE_ERROR";
export const SET_ADMIN_PROJECT = "SET_ADMIN_PROJECT";
export const SET_NOTES = "SET_NOTES";

export const GET_ADMIN_DASHBOARD_TODO_SUCCESS =
  "GET_ADMIN_DASHBOARD_TODO_SUCCESS";
export const GET_ADMIN_DASHBOARD_TODO_ERROR = "GET_ADMIN_DASHBOARD_TODO_ERROR";
export const GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS =
  "GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS";
export const GET_ADMIN_PROJECTS_OVERVIEW_ERROR =
  "GET_ADMIN_PROJECTS_OVERVIEW_ERROR";
export const GET_ADMIN_MEMBERS_OVERVIEW_SUCCESS =
  "GET_ADMIN_MEMBERS_OVERVIEW_SUCCESS";
export const GET_ADMIN_MEMBERS_OVERVIEW_ERROR =
  "GET_ADMIN_MEMBERS_OVERVIEW_ERROR";
export const GET_ADMIN_WEEKLY_PROJECTS_SUCCESS =
  "GET_ADMIN_WEEKLY_PROJECTS_SUCCESS";
export const GET_ADMIN_WEEKLY_PROJECTS_ERROR =
  "GET_ADMIN_WEEKLY_PROJECTS_ERROR";
export const GET_ADMIN_WEEKLY_USERS_SUCCESS = "GET_ADMIN_WEEKLY_USERS_SUCCESS";
export const GET_ADMIN_WEEKLY_USERS_ERROR = "GET_ADMIN_WEEKLY_USERS_ERROR";
export const GET_ADMIN_LIST_SUCCESS = "GET_ADMIN_LIST_SUCCESS";
export const GET_ADMIN_LIST_ERROR = "GET_ADMIN_LIST_ERROR";

const MUST_HAVE = "MUST_HAVE";
const NICE_HAVE = "NICE_HAVE";

export const ADMIN_ADD_REFERENCE_FORM = "NewReferenceForm";
export const ADMIN_CREATE_PROJECTS_FORM = "AdminCreateProjects";
export const ADMIN_CREATE_USERS_FORM = "AdminCreateUsers";
export const ADMIN_SEND_NOTE_FORM = "SendNoteForm";

export function setPagination(data) {
  return {
    type: SET_PAGINATION,
    data
  };
}

export function setPage(data) {
  return {
    type: SET_PAGE,
    data
  };
}

export function setSort(data) {
  return {
    type: SET_SORT,
    data
  };
}

export function setUser(data) {
  return {
    type: SET_USER,
    data
  };
}

export function setMatches(data) {
  return {
    type: SET_MATCHES,
    data
  };
}

export function setMatchesCSV(data) {
  return {
    type: SET_MATCHES_CSV,
    data
  };
}

export function setFeed(data) {
  return {
    type: SET_FEED,
    data
  };
}

export function onCreateAdminSuccess(data) {
  return {
    type: CREATE_ADMIN_SUCCESS,
    data
  };
}

export function onCreateAdminError(error) {
  return {
    type: CREATE_ADMIN_ERROR,
    error
  };
}

export function onShowToast(show) {
  return {
    type: SHOW_TOAST,
    showToast: show
  };
}

export function onGetReferralCodesStart() {
  return {
    type: GET_REFERRAL_CODES_START
  };
}

export function onGetReferralCodesSuccess(data) {
  return {
    type: GET_REFERRAL_CODES_SUCCESS,
    data
  };
}

export function onGetReferralCodesError(error) {
  return {
    type: GET_REFERRAL_CODES_ERROR,
    error
  };
}

export function onUpdateReferralCodeSuccess(data) {
  return {
    type: UPDATE_REFERRAL_CODE_SUCCESS,
    data
  };
}

export function onUpdateReferralCodeError(error) {
  return {
    type: UPDATE_REFERRAL_CODE_ERROR,
    error
  };
}

export function onCreateReferralCodeSuccess(data) {
  return {
    type: CREATE_REFERRAL_CODE_SUCCESS,
    data
  };
}

export function onCreateReferralCodeError(error) {
  return {
    type: CREATE_REFERRAL_CODE_ERROR,
    error
  };
}

export function setAdminProject(data) {
  return {
    type: SET_ADMIN_PROJECT,
    data
  };
}

export function onGetAdminDashboardTodoSuccess(data) {
  return {
    type: GET_ADMIN_DASHBOARD_TODO_SUCCESS,
    data
  };
}

export function onGetAdminDashboardTodoError(error) {
  return {
    type: GET_ADMIN_DASHBOARD_TODO_ERROR,
    error
  };
}

export function getAdminProjectsOverviewSuccess(data) {
  return {
    type: GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS,
    data
  };
}

export function getAdminProjectsOverviewError(error) {
  return {
    type: GET_ADMIN_PROJECTS_OVERVIEW_ERROR,
    error
  };
}

export function getAdminMembersOverviewSuccess(data) {
  return {
    type: GET_ADMIN_MEMBERS_OVERVIEW_SUCCESS,
    data
  };
}

export function getAdminMembersOverviewError(error) {
  return {
    type: GET_ADMIN_MEMBERS_OVERVIEW_ERROR,
    error
  };
}

export function getAdminWeeklyProjectsSuccess(data) {
  return {
    type: GET_ADMIN_WEEKLY_PROJECTS_SUCCESS,
    data
  };
}

export function getAdminWeeklyProjectsError(error) {
  return {
    type: GET_ADMIN_WEEKLY_PROJECTS_ERROR,
    error
  };
}

export function getAdminWeeklyUsersSuccess(data) {
  return {
    type: GET_ADMIN_WEEKLY_USERS_SUCCESS,
    data
  };
}

export function getAdminWeeklyUsersError(error) {
  return {
    type: GET_ADMIN_WEEKLY_USERS_ERROR,
    error
  };
}

export function getAdminListSuccess(data) {
  return {
    type: GET_ADMIN_LIST_SUCCESS,
    data
  };
}

export function getAdminListError(error) {
  return {
    type: GET_ADMIN_LIST_ERROR,
    error
  };
}

export function getUser(userId) {
  return dispatch => {
    dispatch(setLoading(true));
    dispatch(setUser({}));

    api
      .getUser(userId)
      .then(response => {
        dispatch(setUser(response.data.data));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function updateUser(payload) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .adminUpdateUser(payload)
      .then(() => {
        dispatch(getUser(payload.user_id));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function removeUser(userId, companyId = null) {
  return dispatch => {
    if (!companyId) {
      dispatch(setLoading(true));
    }

    api
      .adminRemoveUser(userId)
      .then(() => {
        if (companyId) {
          dispatch(getAdminCompanyById(companyId));
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!companyId) {
          dispatch(setLoading(false));
        }
      });
  };
}

export function sendReminderReference(payload) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .adminSendReminderReference(payload)
      .then(response => {
        dispatch(getUser(response.data.data.referenced_by.id));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function approveReference(payload, userId) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .adminApproveReference(payload)
      .then(() => {
        dispatch(getUser(userId));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function adminAddReference(payload) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .adminAddReference(payload)
      .then(() => {
        dispatch(reset(ADMIN_ADD_REFERENCE_FORM));
        dispatch(getUser(payload.user_id));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function createAdmin(payload) {
  return dispatch => {
    dispatch(startSubmit(ADMIN_CREATE_USERS_FORM));
    api
      .createAdmin(payload)
      .then(res => {
        dispatch(reset(ADMIN_CREATE_USERS_FORM));
        dispatch(onCreateAdminSuccess(res.data));
      })
      .catch(error => {
        dispatch(
          stopSubmit(ADMIN_CREATE_USERS_FORM, error.response.data.errors)
        );
        dispatch(onCreateAdminError(error.response.data));
      });
  };
}

export function showToast(show) {
  return dispatch => {
    dispatch(onShowToast(show));
  };
}

export function getReferralCodes() {
  return dispatch => {
    dispatch(onGetReferralCodesStart());
    api
      .getReferralCodes()
      .then(res => {
        dispatch(onGetReferralCodesSuccess(res.data));
      })
      .catch(error => {
        dispatch(onGetReferralCodesError(error.response.data));
      });
  };
}

export function updateReferralCode(id, active) {
  const payload = {
    id: id,
    active: active
  };
  return dispatch => {
    api
      .updateReferralCode(payload)
      .then(res => {
        dispatch(onUpdateReferralCodeSuccess(res.data));
      })
      .catch(error => {
        dispatch(onUpdateReferralCodeError(error.response.data));
      });
  };
}

export function createReferralCode() {
  return dispatch => {
    api
      .createReferralCode()
      .then(res => {
        dispatch(onCreateReferralCodeSuccess(res.data));
      })
      .catch(error => {
        dispatch(onCreateReferralCodeError(error.response.data));
      });
  };
}

export function getProject(projectId, filters, loading = true, reload = true) {
  return dispatch => {
    dispatch(setLoading(loading));

    if (reload) {
      dispatch(setAdminProject({}));
    }

    api
      .getAdminProject(projectId, filters)
      .then(res => {
        const project = res.data.data;

        project.skills = [];

        if (project.must_skills) {
          project.must_skills.forEach(skill => {
            project.skills[skill.skill_id] = { have: MUST_HAVE };
          });
        }

        if (project.nice_skills) {
          project.nice_skills.forEach(skill => {
            project.skills[skill.skill_id] = { have: NICE_HAVE };
          });
        }

        const location = localStorage.getItem("projectLocation");
        if (location) {
          project.city_obj = JSON.parse(location);
        }

        dispatch(setAdminProject(project));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getProjectMatches(projectId, filters, loading = true) {
  return dispatch => {
    dispatch(setLoading(loading));
    dispatch(setPagination({}));
    dispatch(setMatches({}));

    api
      .getAdminProjectMatches(projectId, filters)
      .then(response => {
        const { data } = response.data;

        dispatch(setPagination(data));
        dispatch(setMatches(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getProjectMatchesCSVData(projectId, filters = "") {
  return dispatch => {
    dispatch(setMatchesCSV({}));

    api
      .getAdminProjectMatchesForCSV(projectId, filters)
      .then(response => {
        const { data } = response.data;
        dispatch(setMatchesCSV(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(setMatchesCSV({}));
      });
  };
}

export function getProjectFeed(projectId) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .getAdminProjectFeed(projectId)
      .then(response => {
        dispatch(setFeed(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getAdminDashboardTodo() {
  return dispatch => {
    api
      .getAdminDashboardTodo()
      .then(res => {
        dispatch(onGetAdminDashboardTodoSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(onGetAdminDashboardTodoError(error.response.data));
      });
  };
}

export function getAdminProjectsOverview() {
  return dispatch => {
    api
      .getAdminProjectsOverview()
      .then(res => {
        dispatch(getAdminProjectsOverviewSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(getAdminProjectsOverviewError(error.response.data));
      });
  };
}

export function updateProject(payload, redirect) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .adminUpdateProject(payload)
      .then(() => {
        dispatch(getProject(payload.project_id));

        if (redirect) {
          dispatch(push(redirect));
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function unpauseProject(projectId) {
  return dispatch => {
    dispatch(setLoading(true));

    api
      .unpauseProject(projectId)
      .then(() => {
        dispatch(push("/admin/projects"));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getAdminMembersOverview() {
  return dispatch => {
    api
      .getAdminMembersOverview()
      .then(res => {
        dispatch(getAdminMembersOverviewSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(getAdminMembersOverviewError(error.response.data));
      });
  };
}

export function getAdminWeeklyProjects() {
  return dispatch => {
    api
      .getAdminWeeklyProjects()
      .then(res => {
        dispatch(getAdminWeeklyProjectsSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(getAdminWeeklyProjectsError(error.response.data));
      });
  };
}

export function getAdminWeeklyUsers() {
  return dispatch => {
    api
      .getAdminWeeklyUsers()
      .then(res => {
        dispatch(getAdminWeeklyUsersSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(getAdminWeeklyUsersError(error.response.data));
      });
  };
}

// Notes
export function setNotes(data) {
  return {
    type: SET_NOTES,
    data
  };
}

export function getAdminUserNotes(userId) {
  return dispatch => {
    dispatch(setNotes([]));

    api
      .getAdminUserNotes(userId)
      .then(response => {
        dispatch(setNotes(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {});
  };
}

export function saveAdminUserNotes(payload) {
  return dispatch => {
    dispatch(startSubmit(ADMIN_SEND_NOTE_FORM));

    api
      .saveAdminUserNotes(payload)
      .then(() => {
        dispatch(getAdminUserNotes(payload.user_id));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(stopSubmit(ADMIN_SEND_NOTE_FORM));
        dispatch(reset(ADMIN_SEND_NOTE_FORM));
      });
  };
}

export function getAdminProjectNotes(projectId) {
  return dispatch => {
    dispatch(setNotes([]));

    api
      .getAdminProjectNotes(projectId)
      .then(response => {
        dispatch(setNotes(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {});
  };
}

export function saveAdminProjectNotes(payload) {
  return dispatch => {
    dispatch(startSubmit(ADMIN_SEND_NOTE_FORM));

    api
      .saveAdminProjectNotes(payload)
      .then(() => {
        dispatch(getAdminProjectNotes(payload.project_id));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(stopSubmit(ADMIN_SEND_NOTE_FORM));
        dispatch(reset(ADMIN_SEND_NOTE_FORM));
      });
  };
}

export function getAdminCompanyNotes(companyId) {
  return dispatch => {
    dispatch(setNotes([]));

    api
      .getAdminCompanyNotes(companyId)
      .then(response => {
        dispatch(setNotes(response.data.data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {});
  };
}

export function saveAdminCompanyNotes(payload) {
  return dispatch => {
    dispatch(startSubmit(ADMIN_SEND_NOTE_FORM));

    api
      .saveAdminCompanyNotes(payload)
      .then(() => {
        dispatch(getAdminCompanyNotes(payload.company_id));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
      })
      .finally(() => {
        dispatch(stopSubmit(ADMIN_SEND_NOTE_FORM));
        dispatch(reset(ADMIN_SEND_NOTE_FORM));
      });
  };
}

export function notifyProjectMatches(payload) {
  return dispatch => {
    dispatch(setLoading(true));
    api
      .notifyProjectMatches(payload)
      .then(() => {
        dispatch(getProject(payload.project_id));
        dispatch(getProjectMatches(payload.project_id, payload.filters));
      })
      .catch(() => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function getPaginationCounts(pagination) {
  if (!pagination.total) {
    return "";
  }

  return (
    pagination.from.toString() +
    " - " +
    pagination.to.toString() +
    " of " +
    pagination.total.toString()
  );
}

export function getAdminList() {
  return dispatch => {
    api
      .getAdminList()
      .then(res => {
        dispatch(getAdminListSuccess(res.data.data));
      })
      .catch(error => {
        dispatch(getAdminListError(error.response.data));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin.actions.js